module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Price"
    },
    model: {
      value: (_vm.itemData.price),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "price", $$v)
      },
      expression: "itemData.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Commission"
    },
    model: {
      value: (_vm.itemData.commission),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "commission", $$v)
      },
      expression: "itemData.commission"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.usersList,
      "label": "Select user"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(_vm._f("normalizeRoles")(props.item.roles)) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(_vm._f("normalizeRoles")(props.item.roles)) + "\n          ")]
      }
    }]),
    model: {
      value: (_vm.itemData.users_id),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "users_id", $$v)
      },
      expression: "itemData.users_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [(_vm.categoriesList) ? _c('v-combobox', {
    attrs: {
      "loading": _vm.loading,
      "items": _vm.categoriesList,
      "search-input": _vm.categorySearch,
      "hide-selected": "",
      "label": "Select category"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.categorySearch = $event
      },
      "update:search-input": function($event) {
        _vm.categorySearch = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.text) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.text) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_c('v-list-tile', {
          staticClass: "pointer"
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
          on: {
            "click": _vm.addCategory
          }
        }, [_vm._v("\n                  No results matching \""), _c('strong', [_vm._v(_vm._s(_vm.categorySearch))]), _vm._v("\". "), _c('kbd', [_vm._v("Click")]), _vm._v(" to create a new category\n                ")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function() {
        return [_c('v-checkbox', {
          staticClass: "checkboxParentCategory",
          attrs: {
            "label": "Set parent category"
          },
          model: {
            value: (_vm.setParentId),
            callback: function($$v) {
              _vm.setParentId = $$v
            },
            expression: "setParentId"
          }
        })]
      },
      proxy: true
    }], null, false, 437995461),
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.categoriesList && _vm.setParentId) ? _c('v-combobox', {
    attrs: {
      "loading": _vm.loading.categories,
      "items": _vm.excludeSelectedCategory,
      "hide-selected": "",
      "label": "Select parent category"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.text) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.text) + "\n          ")]
      }
    }], null, false, 4114375804),
    model: {
      value: (_vm.selectedParentCategory),
      callback: function($$v) {
        _vm.selectedParentCategory = $$v
      },
      expression: "selectedParentCategory"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d72fbee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/AppEditProductsDialog.vue
// module id = 960
// module chunks = 1